import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Breadcrumbs from '../components/Breadcrumbs';
import ModularBlocks from '../components/ModularBlocks';

const DefaultPageTemplate = ({
  data: {
    datoCmsPage: {
      seoMetaTags,
      noIndex,
      title,
      treeParent,
      bannerLink,
      modularBlocks,
    },
  },
  location: { state },
}) => (
  <Layout seo={seoMetaTags} noIndex={noIndex}>
    <main>
      <Breadcrumbs currentPageTitle={title} items={treeParent} />
      <Banner heading={title} link={bannerLink} />
      <ModularBlocks items={modularBlocks} state={state} />
    </main>
  </Layout>
);

export const DefaultPageTemplateQuery = graphql`
  query DefaultPageTemplateQuery($id: String!) {
    datoCmsPage(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      noIndex
      title
      treeParent {
        title
        ...LinkFragment
        treeParent {
          title
          ...LinkFragment
          treeParent {
            title
            ...LinkFragment
          }
        }
      }
      bannerLink {
        text
        pageUrl {
          ...LinkFragment
        }
      }
      modularBlocks {
        ...AccordionModularBlockFragment
        ...ContainedImageModularBlockFragment
        ...ContentModularBlockFragment
        ...ContentBlocksModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...FeaturedCaseStudiesModularBlockFragment
        ...FullWidthImageModularBlockFragment
        ...ImageContentModularBlockV1Fragment
        ...ImageContentModularBlockV2Fragment
        ...InternalVideoModularBlockFragment
        ...LogoContentBlocksModularBlockFragment
        ...NewsletterSignUpModularBlockFragment
        ...PlansModularBlockFragment
        ...PlansOverviewModularBlockFragment
        ...TabsModularBlockFragment
        ...TeamProfilesModularBlockFragment
        ...TestimonialsModularBlockFragment
        ...VideoContentModularBlockFragment
      }
    }
  }
`;

export default DefaultPageTemplate;
